import { type FC } from "react";

import { PeopleSelector } from "@/shared/components/PeopleSelector";
import { Button } from "@/shared/components/ui/button";
import { useUserContacts } from "@/shared/hooks/useUserContacts";
import { findContactIdByName } from "@/shared/utils/confirmedEstateRecords";

import type { PersonContact } from "@/shared/types/estateContact";

interface PersonFieldPickerProps {
  name: string;
  contactId?: number | null;
  filter?: (contact: PersonContact) => boolean;
  onPick: (contact: PersonContact) => void;
  onCancel: () => void;
}

export const PersonFieldPicker: FC<PersonFieldPickerProps> = ({
  name,
  contactId,
  filter,
  onPick,
  onCancel,
}) => {
  const { contacts } = useUserContacts();

  const handleChange = (id: number | null) => {
    // The selector clears a value its filter hides; a single pick can't be cleared by hand.
    const contact = contacts.find((c) => c.id === id);
    if (contact) {
      onPick(contact);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <PeopleSelector
        mode="single"
        className="w-[240px]"
        value={contactId ?? findContactIdByName(contacts, name)}
        onChange={handleChange}
        filter={filter}
      />
      <Button variant="outline" size="sm" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  );
};
